import api from '../api.js';
import { notify } from '../../versa/msgbox.js';
import dialog from '../../versa/dialog.js';
import { findOptionByDocumentDigits } from '../../versa/types/datalist.js';
import * as types from '../types.js';

const STATUS_LABEL = {
	10: 'Criado', 20: 'Congelado', 30: 'Em contagem',
	40: 'Pronto p/ fechar', 50: 'Fechado', 60: 'Cancelado',
};

const COUNT_STATUS_LABEL = {
	pending: 'Pendente',
	count1_done: '1ª contagem feita',
	count2_needed: 'Aguard. 2ª contagem',
	count2_done: '2ª contagem feita',
	count3_needed: 'Aguard. 3ª contagem (gestor)',
	finalized: 'Finalizado',
};

/** Prefixo gravado pelo coletor ao encerrar posição (falta física). */
const CLOSE_LOCATION_PREFIX = '[ENCERRAR POSIÇÃO]';

export default {
	html: `
		<form id="inv-session" class="form sial-modal-form" autocomplete="off">
			<style>
				#inv-session.form.sial-modal-form {
					background-color: var(--color-box, #fff);
					box-sizing: border-box;
				}
				#inv-session { max-width: 68rem; }
				#inv-session fieldset { border: 1px solid #ddd; border-radius: 6px; padding: 10px 14px; margin-bottom: 10px; }
				#inv-session legend { font-weight: 600; color: #1e3a5f; padding: 0 6px; }
				#inv-session .field-row { display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start; margin-bottom: 8px; }
				#inv-session label { display: flex; flex-direction: column; font-size: 0.8rem; }
				#inv-session input, #inv-session select, #inv-session textarea { padding: 4px 6px; border: 1px solid #ccc; border-radius: 4px; font-size: 0.85rem; }
				#inv-session .w-full { width: 100%; }
				#inv-session .w-half { width: calc(50% - 5px); }
				#inv-session .w-third { width: calc(33% - 7px); }
				#inv-session .badge { display: inline-block; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }
				.badge-frozen { background: #dbeafe; color: #1e40af; }
				.badge-counting { background: #fef3c7; color: #92400e; }
				.badge-ready { background: #dcfce7; color: #166534; }
				.badge-closed { background: #f3f4f6; color: #6b7280; }
				.badge-cancelled { background: #fee2e2; color: #991b1b; }
				#inv-items-panel { margin-top: 10px; }
				#inv-items-table-container { max-width: 100%; overflow-x: auto; overflow-y: auto; max-height: min(42vh, 24rem); border: 1px solid #e2e8f0; border-radius: 6px; }
				#inv-items-panel table { width: max-content; min-width: 100%; border-collapse: collapse; font-size: 0.78rem; table-layout: auto; }
				#inv-items-panel th { background: #1e3a5f; color: #fff; padding: 4px 6px; text-align: left; }
				#inv-items-panel th { position: sticky; top: 0; z-index: 1; white-space: nowrap; }
				#inv-items-panel td { padding: 3px 6px; border-bottom: 1px solid #e5e7eb; vertical-align: top; }
				#inv-items-panel tr.finalized td { background: #f0fdf4; }
				#inv-items-panel tr.divergent td { background: #fef3c7; }
				.inv-items-toolbar { display:flex; gap:8px; align-items:center; flex-wrap:wrap; margin: 6px 0 8px; }
				.inv-items-search { flex: 1 1 18rem; min-width: min(100%, 14rem); }
				.inv-items-search input { width: 100%; box-sizing: border-box; }
				.inv-items-count { color:#64748b; font-size:.75rem; }
				.inv-col-id { width: 3.2rem; text-align:right; }
				.inv-col-pos { min-width: 7rem; }
				.inv-col-sku { min-width: 5.5rem; }
				.inv-col-prod { min-width: 13rem; max-width: 18rem; }
				.inv-col-lot { min-width: 8rem; }
				.inv-col-num { width: 4.2rem; text-align:right; }
				.inv-col-status { min-width: 7.5rem; }
				.inv-col-count { min-width: 9rem; }
				.inv-col-details { min-width: 14rem; max-width: 22rem; }
				.inv-progress-track { height: 10px; background: #e5e7eb; border-radius: 999px; overflow: hidden; margin: 6px 0 10px; }
				.inv-progress-fill { height: 100%; background: #16a34a; width: 0%; transition: width .2s ease; }
				.inv-summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(8.5rem, 1fr)); gap: 8px; margin: 8px 0; }
				.inv-card { border: 1px solid #e2e8f0; border-radius: 6px; padding: 8px 10px; background: #f8fafc; }
				.inv-card .label { color: #64748b; font-size: .72rem; }
				.inv-card .value { font-size: 1.1rem; font-weight: 700; margin-top: 2px; }
				.inv-card.inv-card-close { border-color: #d97706; background: #fffbeb; }
				.inv-card.inv-card-close .value { color: #b45309; }
				.inv-status-shortage { display: inline-block; padding: 2px 6px; border-radius: 4px; background: #fef3c7; color: #92400e; font-size: .72rem; font-weight: 600; }
				.inv-status-shortage-done { display: inline-block; padding: 2px 6px; border-radius: 4px; background: #dcfce7; color: #166534; font-size: .72rem; font-weight: 600; }
				.inv-close-tag { display: inline-block; margin-top: 2px; padding: 1px 5px; border-radius: 4px; background: #ffedd5; color: #c2410c; font-size: .68rem; font-weight: 600; }
				#inv-close-location-hint { font-size: .76rem; color: #b45309; margin: 4px 0 0; }
				.inv-filter-row { display:flex; gap:6px; flex-wrap:wrap; margin: 6px 0 8px; }
				.inv-filter-row button { border:1px solid #cbd5e1; border-radius:4px; padding:3px 8px; background:#fff; cursor:pointer; font-size:.75rem; }
				.inv-filter-row button.active { background:#1e3a5f; color:#fff; border-color:#1e3a5f; }
				.count-history { font-size:.72rem; line-height:1.35; color:#334155; }
				.count-history div + div { border-top:1px dotted #cbd5e1; margin-top:2px; padding-top:2px; }
				.count-round-cell { min-width: 8rem; font-size:.72rem; line-height:1.35; color:#334155; }
				.count-round-cell .qty { font-size:.88rem; font-weight:700; color:#0f172a; }
				.count-round-cell .meta { color:#64748b; }
				.count-round-cell .empty { color:#94a3b8; }
				.count-details { min-width: 12rem; font-size:.72rem; line-height:1.35; color:#475569; }
				.count-details div + div { border-top:1px dotted #cbd5e1; margin-top:2px; padding-top:2px; }
				.count-form-row { display: flex; gap: 8px; align-items: flex-end; margin-top: 8px; flex-wrap: wrap; }
				.count-form-row input { padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px; }
				#inv-location-ops-panel { margin-top: 10px; padding: 10px 12px; border: 1px solid #cbd5e1; border-radius: 6px; background: #f8fafc; }
				#inv-location-ops-panel > strong { display: block; font-size: 0.82rem; color: #1e3a5f; margin-bottom: 6px; }
				.inv-loc-ops-row { display: flex; gap: 8px; align-items: flex-end; flex-wrap: wrap; }
				.inv-loc-ops-row label { font-size: 0.78rem; display: flex; flex-direction: column; gap: 2px; }
				.inv-loc-ops-preview { margin-top: 8px; padding: 8px 10px; border-radius: 6px; border: 1px solid #e2e8f0; background: #fff; font-size: 0.78rem; line-height: 1.4; }
				.inv-loc-ops-preview.warn { border-color: #fcd34d; background: #fffbeb; }
				.inv-loc-ops-preview.info { border-color: #93c5fd; background: #eff6ff; }
				.inv-loc-ops-preview ul { margin: 6px 0 0 1rem; padding: 0; }
				.inv-loc-ops-actions { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 8px; }
				.inv-col-actions { min-width: 5.5rem; width: 5.5rem; }
				.inv-row-actions { display: flex; flex-direction: column; gap: 4px; align-items: stretch; }
				.inv-row-actions .bn-action { padding: 3px 6px; font-size: 0.68rem; font-weight: 600; width: 100%; text-align: center; }
				.inv-btn-ghost { background: #fff; color: #1e3a5f; border: 1px solid #cbd5e1; }
				.count-round-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 4px; }
				.inv-btn-del { padding: 0 5px; font-size: 0.65rem; line-height: 1.35; border: none; border-radius: 3px; background: #fee2e2; color: #b91c1c; cursor: pointer; font-weight: 700; flex-shrink: 0; }
				.inv-btn-del:hover { background: #fecaca; }
				.bn-action { padding: 5px 12px; border: none; border-radius: 4px; cursor: pointer; font-size: 0.82rem; font-weight: 600; }
				.bn-primary { background: #1e3a5f; color: #fff; }
				.bn-success { background: #16a34a; color: #fff; }
				.bn-danger { background: #dc2626; color: #fff; }
				.bn-warn { background: #d97706; color: #fff; }
				.sim-summary { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 10px 14px; margin: 8px 0; font-size: 0.82rem; }
			.sim-credit { color: #16a34a; font-weight: 700; }
			.sim-debit { color: #dc2626; font-weight: 700; }
			#import-panel { border-color: #3b82f6; }
			#import-panel legend { color: #1d4ed8; }
			#import-feedback table { width: 100%; border-collapse: collapse; font-size: 0.76rem; margin-top: 6px; }
			#import-feedback th { background: #1e3a5f; color: #fff; padding: 3px 6px; text-align: left; }
			#import-feedback td { padding: 3px 6px; border-bottom: 1px solid #e5e7eb; }
			#import-feedback .row-ok td { background: #f0fdf4; }
			#import-feedback .row-err td { background: #fef2f2; color: #dc2626; }
			.bn-info { background: #0ea5e9; color: #fff; }
				.inv-clear-counts-msgbox { min-width: min(420px, 92vw); max-width: 540px; padding: 0; overflow: hidden; text-align: left; }
				.inv-clear-counts-alert { background: #dc2626; color: #fff; padding: 18px 20px; }
				.inv-clear-counts-alert-title { font-size: 1.15rem; font-weight: 800; margin-bottom: 8px; letter-spacing: 0.02em; }
				.inv-clear-counts-alert p { margin: 0; line-height: 1.5; font-size: 0.92rem; }
				.inv-clear-counts-body { padding: 16px 20px; background: #fff; }
				.inv-clear-counts-code-display { text-align: center; font-size: 2rem; font-weight: 800; letter-spacing: 0.4em; color: #b91c1c; margin: 10px 0 14px; font-family: ui-monospace, monospace; user-select: all; }
				.inv-clear-counts-input { width: 100%; box-sizing: border-box; padding: 10px 12px; font-size: 1.25rem; letter-spacing: 0.35em; text-align: center; font-family: ui-monospace, monospace; border: 2px solid #fca5a5; border-radius: 6px; }
				.inv-clear-counts-input:focus { outline: none; border-color: #dc2626; box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2); }
				.inv-clear-counts-err { color: #dc2626; font-size: 0.85rem; margin: 8px 0 0; display: none; font-weight: 600; }
				.inv-close-status-panel { background: #fffbeb; border: 1px solid #fcd34d; border-radius: 8px; padding: 12px 14px; margin: 10px 0; }
				.inv-close-status-panel.done { background: #f0fdf4; border-color: #86efac; }
				.inv-close-status-panel.error { background: #fef2f2; border-color: #fca5a5; }
				.inv-close-status-panel h4 { margin: 0 0 6px; font-size: 0.92rem; color: #92400e; }
				.inv-close-status-panel.done h4 { color: #166534; }
				.inv-close-status-panel.error h4 { color: #b91c1c; }
				.inv-close-status-track { height: 12px; background: #e5e7eb; border-radius: 999px; overflow: hidden; margin: 8px 0; }
				.inv-close-status-fill { height: 100%; background: linear-gradient(90deg, #d97706, #f59e0b); width: 0%; transition: width .3s ease; }
				.inv-close-status-panel.done .inv-close-status-fill { background: linear-gradient(90deg, #16a34a, #22c55e); }
				.inv-close-status-meta { font-size: 0.78rem; color: #64748b; }
				.inv-close-status-docs { font-size: 0.78rem; color: #334155; margin-top: 6px; }
				.inv-close-confirm-msgbox { min-width: min(440px, 92vw); max-width: 560px; padding: 0; overflow: hidden; text-align: left; }
		</style>

			<fieldset>
				<legend>Identificação</legend>
				<input type="hidden" id="id">
				<div class="field-row">
					<label class="w-half">Empresa*
						<input id="company_id" list="companies" placeholder="Selecione a empresa">
						<datalist id="companies"></datalist>
					</label>
					<label class="w-half">Nome da Sessão*
						<input id="name" type="text" maxlength="120" placeholder="Ex: Inventário Geral - Jun/2026">
					</label>
				</div>
				<div class="field-row">
					<label class="w-third">Tipo*
						<select id="session_type">
							<option value="position" selected>Por posição / armazém</option>
							<option value="product">Por produto</option>
							<option value="import">Importação de planilha</option>
						</select>
					</label>
					<label class="w-half">Observações
						<textarea id="notes" rows="2" style="width:100%;"></textarea>
					</label>
				</div>
			</fieldset>

			<fieldset id="scope-filter-panel">
				<legend>Escopo (filtros de congelamento)</legend>
				<p id="scope-hint" style="font-size:0.78rem; color:#666; margin:0 0 6px 0;">Deixe em branco para inventariar tudo da empresa.</p>
				<p id="scope-import-note" style="font-size:0.82rem; color:#92400e; background:#fef3c7; border-radius:4px; padding:6px 10px; margin:0; display:none;">
					O escopo será definido pela planilha importada abaixo.
				</p>
				<div id="scope-row-location" class="field-row">
					<label class="w-half">Armazéns (IDs numéricos, separados por vírgula, espaço ou ; )
						<input id="scope_warehouse_ids" type="text" placeholder="Ex: 1, 2">
					</label>
					<label class="w-half" id="scope-label-location">Posições (IDs ou endereços, separados por vírgula, espaço ou ; )
						<input id="scope_location_ids" type="text" placeholder="Ex: 3456, 2-M-1-2 ou 2-M-1-2 2-M-1-1">
					</label>
				</div>
				<div id="scope-row-product" class="field-row">
					<label class="w-third">Produtos (IDs ou SKUs)
						<input id="scope_product_ids" type="text" placeholder="Ex: 123, SKU001 ou 2000040981">
					</label>
					<label class="w-third">Categorias (IDs)
						<input id="scope_category_ids" type="text" placeholder="Ex: 10, 11">
					</label>
					<label class="w-third">Classes (IDs)
						<input id="scope_class_ids" type="text" placeholder="Ex: 2, 3">
					</label>
				</div>
			</fieldset>

		<fieldset id="inv-actions-panel" style="display:none;">
			<legend>Ações</legend>
			<div style="display:flex; gap:8px; flex-wrap:wrap; align-items:center;">
				<span id="inv-status-badge" class="badge">-</span>
				<span id="inv-progress-label" style="font-size:0.8rem; color:#555;"></span>
				<button type="button" id="bn-freeze-inv" class="bn-action bn-primary" style="display:none;">Congelar Inventário</button>
				<button type="button" id="bn-unfreeze-inv" class="bn-action bn-warn" style="display:none;">Descongelar Inventário</button>
				<button type="button" id="bn-simulate" class="bn-action bn-warn" style="display:none;">Simular Fechamento</button>
				<button type="button" id="bn-print-progress" class="bn-action bn-primary" style="display:none;">PDF Acompanhamento</button>
				<button type="button" id="bn-print-divergences" class="bn-action bn-primary" style="display:none;">PDF Divergências</button>
				<button type="button" id="bn-print-sim" class="bn-action bn-primary" style="display:none;">PDF Simulação</button>
				<button type="button" id="bn-print-sim-sku" class="bn-action bn-primary" style="display:none;">PDF Simulação SKU</button>
				<button type="button" id="bn-export-sim-sku" class="bn-action bn-primary" style="display:none;">Excel Simulação SKU</button>
				<button type="button" id="bn-print-closure" class="bn-action bn-primary" style="display:none;">PDF Fechamento</button>
				<button type="button" id="bn-close-inv" class="bn-action bn-success" style="display:none;">Fechar Inventário</button>
				<button type="button" id="bn-cancel-inv" class="bn-action bn-danger" style="display:none;">Cancelar Inventário</button>
				<button type="button" id="bn-clear-counts" class="bn-action bn-danger" style="display:none;">Cancelar Contagens</button>
				<button type="button" id="bn-reload-items" class="bn-action bn-primary" style="display:none;">Atualizar Itens</button>
				<button type="button" id="bn-export-counts" class="bn-action bn-primary" style="display:none;">Exportar Contagens</button>
			</div>
			<div id="inv-summary-panel" style="display:none;">
				<div class="inv-progress-track"><div id="inv-progress-fill" class="inv-progress-fill"></div></div>
				<div id="inv-summary-cards" class="inv-summary-grid"></div>
				<p id="inv-close-location-hint" style="display:none;"></p>
				<p id="inv-last-count" style="font-size:.76rem; color:#64748b; margin:4px 0;"></p>
			</div>
			<div id="sim-summary-panel" class="sim-summary" style="display:none;">
				<strong>Simulação:</strong>
				<span id="sim-total"></span> itens —
				<span class="sim-credit" id="sim-credit"></span>,
				<span class="sim-debit" id="sim-debit"></span>
				<span id="sim-net" style="font-weight:700; margin-left:6px;"></span>
			</div>
			<div id="inv-close-status-panel" class="inv-close-status-panel" style="display:none;" role="status" aria-live="polite">
				<h4 id="inv-close-status-title">Fechamento em andamento no servidor</h4>
				<p id="inv-close-status-msg" style="margin:0 0 6px;font-size:0.82rem;color:#475569;">Processando ajustes de estoque. Você pode fechar esta aba — o fechamento continua no servidor.</p>
				<div class="inv-close-status-track"><div id="inv-close-status-fill" class="inv-close-status-fill"></div></div>
				<div id="inv-close-status-meta" class="inv-close-status-meta">0%</div>
				<div id="inv-close-status-docs" class="inv-close-status-docs" style="display:none;"></div>
				<div id="inv-close-status-error" style="display:none;color:#dc2626;font-weight:600;font-size:0.82rem;margin-top:6px;"></div>
			</div>
			<div id="count-panel" style="display:none; margin-top:10px;">
				<strong style="font-size:0.82rem;">Registrar Contagem Cega</strong>
				<div class="count-form-row">
					<label style="font-size:0.78rem;">Posição<input id="count-location-code" type="text" style="width:7rem;" placeholder="2-M-1-2"></label>
					<label style="font-size:0.78rem;">SKU<input id="count-sku" type="text" style="width:7rem;"></label>
					<label style="font-size:0.78rem;">Lote<input id="count-lot-number" type="text" style="width:7rem;"></label>
					<label style="font-size:0.78rem;">Validade<input id="count-expiration-date" type="date" style="width:8rem;"></label>
					<label style="font-size:0.78rem;">Quantidade<input id="count-qty" type="number" min="0" style="width:6rem;"></label>
					<label style="font-size:0.78rem;">Observação<input id="count-obs" type="text" style="width:12rem;"></label>
					<button type="button" id="bn-save-count" class="bn-action bn-primary">Salvar Contagem</button>
				</div>
				<p style="font-size:0.75rem; color:#64748b; margin:4px 0;">Inventário cego: digite os dados encontrados fisicamente. O programa é resolvido internamente pelo SKU/produto.</p>
				<p id="count-feedback" style="font-size:0.8rem; min-height:1.4rem; margin:4px 0; color:#16a34a;"></p>
			</div>
			<div id="inv-location-ops-panel" style="display:none;">
				<strong>Operações por posição</strong>
				<span style="font-size:0.72rem; color:#64748b; display:block; margin-bottom:6px;">Encerrar posição: 1ª rodada registra falta (qty 0); 2ª rodada confirma a falta — outro operador. Terminei os achados: só posição vazia.</span>
				<div class="inv-loc-ops-row">
					<label>Posição
						<input id="loc-ops-code" type="text" style="width:7rem;" placeholder="2-A-47-2">
					</label>
					<button type="button" id="bn-loc-close-preview" class="bn-action bn-warn" title="1ª rodada: registrar falta dos pendentes. 2ª rodada: confirmar falta (outro operador).">Encerrar posição</button>
					<button type="button" id="bn-loc-finalize-preview" class="bn-action bn-primary" title="Posição vazia com achados coletados">Terminei os achados</button>
				</div>
				<div id="inv-loc-ops-preview" class="inv-loc-ops-preview" style="display:none;"></div>
			</div>
		</fieldset>

			<fieldset id="inv-import-panel" style="display:none;">
				<legend>Importar Planilha</legend>
				<p id="import-create-note" style="font-size:0.78rem; color:#555; margin:0 0 8px 0; display:none;">
					Se a sessão ainda não foi salva, ela será criada automaticamente ao importar (empresa e nome são obrigatórios).
				</p>
				<div style="display:flex; gap:8px; align-items:center; flex-wrap:wrap;">
					<button type="button" id="bn-download-template-detail" class="bn-action bn-primary" style="font-size:0.78rem;">⬇ Baixar Modelo CSV</button>
					<label style="font-size:0.78rem; cursor:pointer; display:inline-flex; align-items:center; gap:6px;">
						<input type="file" id="import-file-input" accept=".csv,.txt" style="display:none;">
						<span class="bn-action" style="background:#e5e7eb; color:#1f2937; padding:5px 12px; border-radius:4px; font-weight:600; font-size:0.82rem; cursor:pointer;">📂 Selecionar arquivo</span>
						<span id="import-file-name" style="color:#555; font-size:0.78rem; font-style:italic;">Nenhum arquivo selecionado</span>
					</label>
					<button type="button" id="bn-import-spreadsheet" class="bn-action bn-success" style="font-size:0.78rem;" disabled>▶ Importar</button>
				</div>
				<p id="import-feedback" style="font-size:0.8rem; min-height:1.4rem; margin:6px 0 0; color:#16a34a;"></p>
			</fieldset>

		<div id="inv-items-panel" style="display:none;">
				<h4 style="margin:8px 0 4px; font-size:0.85rem; color:#1e3a5f;">Itens do Escopo</h4>
				<div class="inv-items-toolbar">
					<div id="inv-item-filters" class="inv-filter-row">
						<button type="button" data-filter="all" class="active">Todos</button>
						<button type="button" data-filter="pending">Pendentes</button>
						<button type="button" data-filter="count2">2ª contagem</button>
						<button type="button" data-filter="count3">3ª contagem</button>
						<button type="button" data-filter="finalized">Finalizados</button>
						<button type="button" data-filter="divergent">Divergências</button>
						<button type="button" data-filter="close_location">Falta física</button>
					</div>
					<label class="inv-items-search" title="Busca em posição, SKU, produto, lote, status, operador e dados digitados">
						<input id="inv-item-search" type="search" placeholder="Buscar em qualquer coluna...">
					</label>
					<span id="inv-items-count" class="inv-items-count"></span>
				</div>
				<div id="inv-items-table-container"><p style="color:#999; font-size:0.8rem;">Carregando itens...</p></div>
			</div>

			<div style="display:flex; gap:8px; justify-content:flex-end; margin-top:10px;">
				<button type="button" class="bn_Escape button">Fechar</button>
				<button type="button" class="bn_Enter button" id="bn-save-session">Salvar</button>
			</div>
		</form>
	`,

	form: {
		selector: '#inv-session',
		init(formset) {
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const root = document.querySelector('#inv-session');
			if (root) {
				root.dataset.sessionId = '';
				root.dataset.importBound = '';
				root.dataset.invSessionBound = '';
				const typeEl = root.querySelector('#session_type');
				_adaptScopeByType(typeEl?.value || 'position', root);
				typeEl?.addEventListener('change', () => _adaptScopeByType(typeEl.value, root));
			}
		},
		afterEditSetValues(fs) {
			const vals = fs.form.getValues?.() || {};
			const root = document.querySelector('#inv-session');
			const companyId = root
				? _resolveDatalistValue(root.querySelector('#company_id'))
				: vals.company_id;
			const sessionId = vals.id;
			if (root) {
				root.dataset.sessionId = sessionId ? String(sessionId) : '';
				const typeEl = root.querySelector('#session_type');
				_adaptScopeByType(typeEl?.value || 'position', root);
			}
			if (sessionId && companyId)
				_showSessionDetail({ ...vals, id: sessionId, company_id: companyId });
		},
	},

	fields: [
		{ properties: { selector: '#id' }, types: [types.number()] },
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#session_type' }, types: [types.select()] },
		{ properties: { selector: '#notes' }, types: [types.textarea()] },
		{ properties: { selector: '#scope_warehouse_ids' }, types: [] },
		{ properties: { selector: '#scope_location_ids' }, types: [] },
		{ properties: { selector: '#scope_product_ids' }, types: [] },
		{ properties: { selector: '#scope_category_ids' }, types: [] },
		{ properties: { selector: '#scope_class_ids' }, types: [] },
	],
};

function _downloadTemplateCsv() {
	const content = 'sku;lot_number;location_code;warehouse_code;quantity_expected\n004212;13620;1-A-01-1;;0\n';
	const blob = new Blob(['\uFEFF' + content], { type: 'text/csv;charset=utf-8;' });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = 'modelo_inventario.csv';
	a.click();
	URL.revokeObjectURL(url);
}

function _adaptScopeByType(type, root) {
	const panel      = root.querySelector('#scope-filter-panel');
	const hint       = root.querySelector('#scope-hint');
	const importNote = root.querySelector('#scope-import-note');
	const rowLoc     = root.querySelector('#scope-row-location');
	const labelLoc   = root.querySelector('#scope-label-location');
	const rowProd    = root.querySelector('#scope-row-product');
	const importPanel = root.querySelector('#inv-import-panel');
	const createNote = root.querySelector('#import-create-note');
	if (!panel) return;

	if (type === 'import') {
		if (hint)       hint.style.display = 'none';
		if (importNote) importNote.style.display = '';
		if (rowLoc)     rowLoc.style.display = 'none';
		if (rowProd)    rowProd.style.display = 'none';
		if (importPanel) importPanel.style.display = '';
		if (createNote) createNote.style.display = root.dataset.sessionId ? 'none' : '';
		_bindImportPanel(root);
		return;
	}

	if (importPanel) importPanel.style.display = 'none';
	if (createNote) createNote.style.display = 'none';
	if (hint)       hint.style.display = '';
	if (importNote) importNote.style.display = 'none';

	if (type === 'position') {
		if (rowLoc)   rowLoc.style.display = '';
		if (labelLoc) labelLoc.style.display = '';
		if (rowProd)  rowProd.style.display = '';
	} else if (type === 'product') {
		if (rowLoc)   rowLoc.style.display = '';
		if (labelLoc) labelLoc.style.display = 'none';
		if (rowProd)  rowProd.style.display = '';
	}
}

function _resolveDatalistValue(node) {
	if (!node)
		return '';
	const raw = String(node.value || '').trim();
	if (!raw)
		return '';
	if (!node.list?.options?.length)
		return raw;
	let option = Array.from(node.list.options).find(
		(opt) => opt.innerText && opt.innerText.trim() === raw,
	);
	if (!option)
		option = findOptionByDocumentDigits(node.list.options, raw);
	return option?.value || raw;
}

function _readFormBasics(root) {
	const companyId = _resolveDatalistValue(root.querySelector('#company_id'));
	const name = root.querySelector('#name')?.value?.trim() || '';
	const sessionType = root.querySelector('#session_type')?.value || 'position';
	const notes = root.querySelector('#notes')?.value?.trim() || '';
	return { companyId, name, sessionType, notes };
}

async function _ensureSessionForImport(root) {
	let sessionId = root.dataset.sessionId ? parseInt(root.dataset.sessionId, 10) : null;
	const { companyId, name, sessionType, notes } = _readFormBasics(root);
	if (!companyId) {
		notify('Selecione a empresa antes de importar.');
		return null;
	}
	if (!name) {
		notify('Informe o nome da sessão antes de importar.');
		return null;
	}
	if (sessionType !== 'import') {
		notify('Tipo de sessão deve ser Importação de planilha.');
		return null;
	}
	if (sessionId)
		return { companyId, sessionId };

	const res = await api.create_inventory_session({
		company_id: companyId,
		session_type: 'import',
		name,
		notes: notes || null,
		scope_filter: null,
		freeze_immediately: false,
	});
	if (!res.ok) {
		notify(await _apiErrorText(res));
		return null;
	}
	const created = await res.json();
	sessionId = created.id;
	root.dataset.sessionId = String(sessionId);
	const createNote = root.querySelector('#import-create-note');
	if (createNote) createNote.style.display = 'none';
	notify(`Sessão #${sessionId} criada. Importando planilha...`, 'success');
	return { companyId, sessionId };
}

function _bindImportPanel(root) {
	if (root.dataset.importBound === '1')
		return;
	root.dataset.importBound = '1';

	const btnTplDetail = root.querySelector('#bn-download-template-detail');
	const fileInput    = root.querySelector('#import-file-input');
	const fileName     = root.querySelector('#import-file-name');
	const btnImport    = root.querySelector('#bn-import-spreadsheet');
	const feedback     = root.querySelector('#import-feedback');

	btnTplDetail?.addEventListener('click', _downloadTemplateCsv);

	fileInput?.addEventListener('change', () => {
		const f = fileInput.files?.[0];
		if (fileName) fileName.textContent = f ? f.name : 'Nenhum arquivo selecionado';
		if (btnImport) btnImport.disabled = !f;
		if (feedback) feedback.textContent = '';
	});

	btnImport?.addEventListener('click', async () => {
		const f = fileInput?.files?.[0];
		if (!f) return;
		if (feedback) {
			feedback.textContent = 'Preparando importação...';
			feedback.style.color = '#555';
		}
		btnImport.disabled = true;
		try {
			const ctx = await _ensureSessionForImport(root);
			if (!ctx) return;

			const text = await f.text();
			const rows = _parseCsv(text);
			if (!rows.length) {
				if (feedback) {
					feedback.textContent = 'Arquivo vazio ou sem linhas válidas.';
					feedback.style.color = '#dc2626';
				}
				return;
			}

			if (feedback) feedback.textContent = `Enviando ${rows.length} linhas...`;
			const res = await api.import_inventory_spreadsheet(ctx.companyId, ctx.sessionId, rows, f.name);
			if (!res.ok) {
				if (feedback) {
					feedback.textContent = await _apiErrorText(res);
					feedback.style.color = '#dc2626';
				}
				return;
			}
			const result = await res.json();
			if (feedback) {
				feedback.innerHTML = _buildImportResult(result);
				feedback.style.color = '';
			}
			fileInput.value = '';
			if (fileName) fileName.textContent = 'Nenhum arquivo selecionado';

			if (!root.dataset.invSessionBound) {
				root.dataset.invSessionBound = '1';
				await _showSessionDetail({
					company_id: ctx.companyId,
					id: ctx.sessionId,
					session_type: 'import',
				});
			} else if (typeof root._invRefresh === 'function') {
				await root._invRefresh();
			}
		} catch (e) {
			if (feedback) {
				feedback.textContent = String(e);
				feedback.style.color = '#dc2626';
			}
		} finally {
			if (btnImport) btnImport.disabled = !fileInput?.files?.[0];
		}
	});
}

/**
 * Bloqueia identificação e escopo após a sessão sair do status Criado.
 * @param {HTMLElement} root
 * @param {number} status
 */
function _lockIdentificationFields(root, status) {
	const locked = Number(status) !== 10;
	const selectors = [
		'#company_id', '#name', '#session_type', '#notes',
		'#scope_warehouse_ids', '#scope_location_ids', '#scope_product_ids',
		'#scope_category_ids', '#scope_class_ids',
	];
	selectors.forEach((sel) => {
		const el = root.querySelector(sel);
		if (el) el.disabled = locked;
	});
	const saveBtn = root.querySelector('#bn-save-session');
	if (saveBtn) saveBtn.style.display = locked ? 'none' : '';
	let note = root.querySelector('#inv-readonly-note');
	if (locked) {
		if (!note) {
			note = document.createElement('p');
			note.id = 'inv-readonly-note';
			note.style.cssText = 'font-size:0.78rem;color:#64748b;margin:0 0 8px 0;';
			note.textContent = 'Sessão iniciada: identificação e escopo não podem mais ser alterados.';
			const firstFieldset = root.querySelector('fieldset');
			if (firstFieldset) firstFieldset.insertBefore(note, firstFieldset.firstChild);
		}
	} else if (note) {
		note.remove();
	}
}

/** Gera código numérico de 6 dígitos para confirmação de ações destrutivas. */
function _generateClearCountsConfirmCode() {
	return String(Math.floor(100000 + Math.random() * 900000));
}

/**
 * Modal de contra-senha — cancelar todas as contagens do inventário.
 * @param {function} onConfirm
 */
function _openClearCountsConfirmModal(onConfirm) {
	const code = _generateClearCountsConfirmCode();
	const html = `
		<div class="msgbox inv-clear-counts-msgbox">
			<div class="inv-clear-counts-alert">
				<div class="inv-clear-counts-alert-title">ATENÇÃO — Ação irreversível</div>
				<p>
					Serão <strong>excluídas todas as contagens</strong> deste inventário.
					O escopo congelado será removido e a sessão voltará para <strong>Criado</strong>,
					permitindo cancelar o inventário. Esta ação não pode ser desfeita.
				</p>
			</div>
			<div class="inv-clear-counts-body">
				<p style="margin:0 0 8px;color:#334155;font-size:0.9rem">
					Para confirmar, digite o código de 6 dígitos abaixo:
				</p>
				<div class="inv-clear-counts-code-display" aria-label="Código de confirmação">${code}</div>
				<input type="text" id="inv-clear-counts-code" class="inv-clear-counts-input"
					inputmode="numeric" maxlength="6" pattern="[0-9]*" autocomplete="off"
					placeholder="000000" aria-label="Digite o código de confirmação">
				<p id="inv-clear-counts-err" class="inv-clear-counts-err">Código incorreto.</p>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Confirmar exclusão</button>
		</div>
	`;

	const dlg = dialog.create(html, (key) => {
		if (key === 'Escape' || key === 'N') {
			dlg.destroy();
			return;
		}
		if (key !== 'Y' && key !== 'Enter') return;

		const node = dlg.getNode();
		const input = node.querySelector('#inv-clear-counts-code');
		const typed = (input?.value || '').replace(/\D/g, '');
		if (typed !== code) {
			const err = node.querySelector('#inv-clear-counts-err');
			if (err) {
				err.style.display = 'block';
				err.textContent = 'Código incorreto. Digite exatamente os 6 dígitos exibidos acima.';
			}
			input?.focus();
			input?.select();
			return;
		}
		dlg.destroy();
		if (typeof onConfirm === 'function') onConfirm();
	}, /Enter|Escape|N|Y/);

	setTimeout(() => dlg.getNode().querySelector('#inv-clear-counts-code')?.focus(), 0);
}

function _openCloseConfirmModal(onConfirm) {
	const code = _generateClearCountsConfirmCode();
	const html = `
		<div class="msgbox inv-close-confirm-msgbox">
			<div class="inv-clear-counts-alert">
				<div class="inv-clear-counts-alert-title">FECHAMENTO DEFINITIVO — IRREVERSÍVEL</div>
				<p>
					Esta ação <strong>não pode ser cancelada</strong>. O sistema irá gerar
					<strong>1 entrada</strong> com todas as sobras e <strong>1 saída</strong> com todas as faltas,
					ajustando o estoque real. O processamento continua <strong>no servidor</strong> mesmo se você fechar o navegador.
				</p>
			</div>
			<div class="inv-clear-counts-body">
				<p style="margin:0 0 8px;color:#334155;font-size:0.9rem">
					Para confirmar o fechamento, digite o código de 6 dígitos:
				</p>
				<div class="inv-clear-counts-code-display" aria-label="Código de confirmação">${code}</div>
				<input type="text" id="inv-close-confirm-code" class="inv-clear-counts-input"
					inputmode="numeric" maxlength="6" pattern="[0-9]*" autocomplete="off"
					placeholder="000000" aria-label="Digite o código de confirmação">
				<p id="inv-close-confirm-err" class="inv-clear-counts-err">Código incorreto.</p>
			</div>
			<button type="button" class="button mtl bn_N">Cancelar</button>
			<button type="button" class="button mtl bn_Y">Iniciar fechamento</button>
		</div>
	`;

	const dlg = dialog.create(html, (key) => {
		if (key === 'Escape' || key === 'N') {
			dlg.destroy();
			return;
		}
		if (key !== 'Y' && key !== 'Enter') return;

		const node = dlg.getNode();
		const input = node.querySelector('#inv-close-confirm-code');
		const typed = (input?.value || '').replace(/\D/g, '');
		if (typed !== code) {
			const err = node.querySelector('#inv-close-confirm-err');
			if (err) {
				err.style.display = 'block';
				err.textContent = 'Código incorreto. Digite exatamente os 6 dígitos exibidos acima.';
			}
			input?.focus();
			input?.select();
			return;
		}
		dlg.destroy();
		if (typeof onConfirm === 'function') onConfirm();
	}, /Enter|Escape|N|Y/);

	setTimeout(() => dlg.getNode().querySelector('#inv-close-confirm-code')?.focus(), 0);
}

/** Atualiza painel inline de status do fechamento (somente leitura). */
function _renderCloseJobPanel(root, job) {
	const panel = root.querySelector('#inv-close-status-panel');
	if (!panel) return;
	const fill = panel.querySelector('#inv-close-status-fill');
	const msgEl = panel.querySelector('#inv-close-status-msg');
	const metaEl = panel.querySelector('#inv-close-status-meta');
	const docsEl = panel.querySelector('#inv-close-status-docs');
	const errEl = panel.querySelector('#inv-close-status-error');
	const titleEl = panel.querySelector('#inv-close-status-title');

	const status = job?.status || 'idle';
	if (status === 'idle') {
		panel.style.display = 'none';
		return;
	}

	panel.style.display = '';
	panel.classList.remove('done', 'error');
	const pct = Math.max(0, Math.min(100, Number(job?.progress_percent || 0)));
	if (fill) fill.style.width = `${pct}%`;

	if (status === 'running') {
		titleEl.textContent = 'Fechamento em andamento no servidor';
		if (msgEl) msgEl.textContent = job?.message || 'Processando ajustes de estoque…';
	} else if (status === 'done') {
		panel.classList.add('done');
		titleEl.textContent = 'Inventário fechado com sucesso';
		if (msgEl) msgEl.textContent = job?.message || 'Ajustes aplicados. Consulte o PDF de fechamento.';
	} else if (status === 'error') {
		panel.classList.add('error');
		titleEl.textContent = 'Erro no fechamento';
		if (msgEl) msgEl.textContent = job?.message || 'Falha ao processar o fechamento.';
	}

	const step = Number(job?.step_index || 0);
	const total = Number(job?.total_steps || 0);
	if (metaEl) {
		metaEl.textContent = total
			? `${pct}% — etapa ${Math.min(step, total)} / ${total}${job?.phase ? ` (${job.phase})` : ''}`
			: `${pct}%`;
	}

	if (docsEl) {
		const parts = [];
		if (job?.input_id) parts.push(`Entrada #${job.input_id}`);
		if (job?.output_id) parts.push(`Saída #${job.output_id}`);
		if (parts.length) {
			docsEl.style.display = '';
			docsEl.textContent = parts.join(' · ');
		} else {
			docsEl.style.display = 'none';
		}
	}

	if (errEl) {
		if (status === 'error' && job?.error) {
			errEl.style.display = '';
			errEl.textContent = job.error;
		} else {
			errEl.style.display = 'none';
		}
	}
}

/** Polling leve de status — não dirige o fechamento (servidor orquestra). */
function _ensureCloseJobPolling(companyId, sessionId, root) {
	if (root._invClosePollTimer) return;
	root._invClosePollTimer = setInterval(async () => {
		try {
			const res = await api.get_inventory_close_job_status(companyId, sessionId);
			if (!res.ok) return;
			const job = await res.json();
			_renderCloseJobPanel(root, job);
			if (job?.status === 'done') {
				clearInterval(root._invClosePollTimer);
				root._invClosePollTimer = null;
				notify('Inventário fechado com sucesso.', 'success');
				if (typeof root._invRefresh === 'function') await root._invRefresh();
			} else if (job?.status === 'error') {
				clearInterval(root._invClosePollTimer);
				root._invClosePollTimer = null;
				notify(job?.error || job?.message || 'Erro no fechamento.', 'error');
				if (typeof root._invRefresh === 'function') await root._invRefresh();
			}
		} catch {
			/* polling silencioso */
		}
	}, 2500);
}

async function _startInventoryCloseJob(companyId, sessionId, root) {
	const res = await api.start_inventory_close_job(companyId, sessionId);
	if (!res.ok) {
		notify(await _apiErrorText(res), 'error');
		return;
	}
	const job = await res.json();
	_renderCloseJobPanel(root, job);
	_ensureCloseJobPolling(companyId, sessionId, root);
	if (typeof root._invRefresh === 'function') await root._invRefresh();
}

function _stopCloseJobPolling(root) {
	if (root._invClosePollTimer) {
		clearInterval(root._invClosePollTimer);
		root._invClosePollTimer = null;
	}
}

async function _showSessionDetail(vals) {
	const root = document.querySelector('#inv-session');
	if (!root)
		return;

	const companyId = _resolveDatalistValue(root.querySelector('#company_id')) || vals.company_id;
	const sessionId = vals.id || root.dataset.sessionId;
	if (!companyId || !sessionId)
		return;

	root.dataset.sessionId = String(sessionId);
	root.dataset.invItemFilter = root.dataset.invItemFilter || 'all';
	_bindImportPanel(root);

	const isFirstBind = root.dataset.invSessionBound !== '1';
	root.dataset.invSessionBound = '1';

	const actionsPanel = root.querySelector('#inv-actions-panel');
	const statusBadge = root.querySelector('#inv-status-badge');
	const progressLabel = root.querySelector('#inv-progress-label');
	const btnFreeze = root.querySelector('#bn-freeze-inv');
	const btnUnfreeze = root.querySelector('#bn-unfreeze-inv');
	const btnSimulate = root.querySelector('#bn-simulate');
	const btnPrintProgress = root.querySelector('#bn-print-progress');
	const btnPrintDivergences = root.querySelector('#bn-print-divergences');
	const btnPrintSim = root.querySelector('#bn-print-sim');
	const btnPrintSimSku = root.querySelector('#bn-print-sim-sku');
	const btnExportSimSku = root.querySelector('#bn-export-sim-sku');
	const btnPrintClosure = root.querySelector('#bn-print-closure');
	const btnClose = root.querySelector('#bn-close-inv');
	const btnCancel = root.querySelector('#bn-cancel-inv');
	const btnClearCounts = root.querySelector('#bn-clear-counts');
	const btnReload = root.querySelector('#bn-reload-items');
	const btnExportCounts = root.querySelector('#bn-export-counts');
	const summaryPanel = root.querySelector('#inv-summary-panel');
	const countPanel = root.querySelector('#count-panel');
	const simSummary = root.querySelector('#sim-summary-panel');
	const itemsPanel = root.querySelector('#inv-items-panel');
	const scopeFilter = root.querySelector('#scope-filter-panel');

	if (actionsPanel) actionsPanel.style.display = '';
	if (scopeFilter) scopeFilter.style.display = 'none';
	_lockIdentificationFields(root, vals.status ?? 10);

	const sessionType = vals.session_type || '';
	const importPanel = root.querySelector('#inv-import-panel');
	const btnImport = root.querySelector('#bn-import-spreadsheet');
	const fileInput = root.querySelector('#import-file-input');

	const _updateImportPanel = (status) => {
		if (!importPanel || sessionType !== 'import') return;
		importPanel.style.display = '';
		const canImport = status === 10;
		if (fileInput) fileInput.disabled = !canImport;
		if (btnImport) btnImport.disabled = !canImport || !fileInput?.files?.[0];
		const fb = root.querySelector('#import-feedback');
		if (fb && !canImport && !fb.textContent)
			fb.textContent = 'Sessão já congelada — não é possível importar nova planilha.';
	};

	const refresh = async () => {
		try {
			const res = await api.select_inventory_session(companyId, sessionId);
			if (!res.ok) {
				notify(await _apiErrorText(res));
				return;
			}
			const s = await res.json();
			_lockIdentificationFields(root, s.status);
			const summary = await _loadSummary(companyId, sessionId);

			_updateImportPanel(s.status);
			statusBadge.textContent = STATUS_LABEL[s.status] || s.status;
			statusBadge.className = `badge ${_badgeClass(s.status)}`;
			const pct = summary?.progress_percent ?? (s.total_items ? Math.round((s.finalized_items / s.total_items) * 100) : 0);
			progressLabel.textContent = `${summary?.finalized_items ?? s.finalized_items ?? 0} / ${summary?.total_items ?? s.total_items ?? 0} itens finalizados (${pct}%)`;
			const open = [20, 30, 40].includes(s.status);
			if (summaryPanel) summaryPanel.style.display = '';
			root.dataset.invBlindMode = [20, 30].includes(s.status) ? '1' : '';
			root.dataset.invCountsEditable = ![50, 60].includes(s.status) ? '1' : '';
			if (open || s.status === 50)
				await _loadItems(companyId, sessionId, root.dataset.invItemFilter || 'all', ![50, 60].includes(s.status));
			else
				root._invItems = [];
			_renderSummary(summary || {
				status_label: STATUS_LABEL[s.status] || s.status,
				total_items: s.total_items || 0,
				finalized_items: s.finalized_items || 0,
				progress_percent: pct,
			}, root._invItems || []);

			btnFreeze.style.display = s.status === 10 && s.session_type !== 'import' ? '' : 'none';
			btnUnfreeze.style.display = s.status === 20 ? '' : 'none';
			btnSimulate.style.display = (summary?.can_simulate ?? s.status === 40) ? '' : 'none';
			btnPrintProgress.style.display = (summary?.total_items || 0) > 0 ? '' : 'none';
			btnPrintDivergences.style.display = (summary?.divergent_items || summary?.total_counts || 0) > 0 ? '' : 'none';
			btnPrintSim.style.display = s.simulation_snapshot ? '' : 'none';
			if (btnPrintSimSku) btnPrintSimSku.style.display = s.simulation_snapshot ? '' : 'none';
			if (btnExportSimSku) btnExportSimSku.style.display = s.simulation_snapshot ? '' : 'none';
			btnPrintClosure.style.display = s.status === 50 ? '' : 'none';
			btnClose.style.display = (summary?.can_close ?? (s.status === 40 && s.simulation_snapshot)) && !(s.close_job?.status === 'running') ? '' : 'none';
			const closeJob = s.close_job || null;
			if (closeJob?.status === 'running' || closeJob?.status === 'error') {
				_renderCloseJobPanel(root, {
					...closeJob,
					progress_percent: closeJob.progress_percent ?? 0,
					step_index: closeJob.step_index ?? 0,
					total_steps: closeJob.total_steps ?? 0,
				});
				if (closeJob.status === 'running') {
					_ensureCloseJobPolling(companyId, sessionId, root);
				}
			} else if (closeJob?.status === 'done') {
				_renderCloseJobPanel(root, closeJob);
			} else {
				_renderCloseJobPanel(root, { status: 'idle' });
			}
			btnCancel.style.display = s.status === 10 ? '' : 'none';
			btnClearCounts.style.display = (summary?.total_counts || 0) > 0 && ![50, 60].includes(s.status) ? '' : 'none';
			btnReload.style.display = (open || s.status === 50) ? '' : 'none';
			btnExportCounts.style.display = (summary?.total_counts || 0) > 0 ? '' : 'none';
			countPanel.style.display = [20, 30].includes(s.status) ? '' : 'none';
			const locOpsPanel = root.querySelector('#inv-location-ops-panel');
			if (locOpsPanel) locOpsPanel.style.display = [20, 30].includes(s.status) ? '' : 'none';
			itemsPanel.style.display = (open || s.status === 50) ? '' : 'none';

			if (s.simulation_snapshot) {
				simSummary.style.display = '';
				const snap = typeof s.simulation_snapshot === 'string'
					? JSON.parse(s.simulation_snapshot)
					: s.simulation_snapshot;
				const fmtQty = (n) => Number(n || 0).toLocaleString('pt-BR');
				const fmtMoney = (n) => {
					const v = Number(n || 0);
					const sign = v > 0 ? '+' : v < 0 ? '−' : '';
					return `${sign}R$ ${Math.abs(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
				};
				const creditQty = snap.total_credit_qty || 0;
				const debitQty = snap.total_debit_qty || 0;
				const netQty = snap.net_qty ?? (creditQty - debitQty);
				const creditVal = snap.total_credit_value || 0;
				const debitVal = snap.total_debit_value || 0;
				const netVal = snap.net_value ?? (creditVal - debitVal);
				root.querySelector('#sim-total').textContent = snap.total_items || 0;
				root.querySelector('#sim-credit').textContent =
					`sobras +${fmtQty(creditQty)} un. (${snap.credit_count || 0}) · ${fmtMoney(creditVal)}`;
				root.querySelector('#sim-debit').textContent =
					`faltas −${fmtQty(debitQty)} un. (${snap.debit_count || 0}) · ${fmtMoney(-debitVal)}`;
				const netEl = root.querySelector('#sim-net');
				if (netEl) {
					const netClass = netQty >= 0 ? 'sim-credit' : 'sim-debit';
					netEl.className = netClass;
					netEl.textContent = `Saldo líquido: ${netQty >= 0 ? '+' : '−'}${fmtQty(Math.abs(netQty))} un. · ${fmtMoney(netVal)}`;
				}
			} else {
				simSummary.style.display = 'none';
			}
		} catch (e) {
			notify(String(e));
		}
	};
	root._invRefresh = refresh;

	if (isFirstBind) {
		btnFreeze.addEventListener('click', async () => {
			if (!confirm('Congelar este inventário?')) return;
			const res = await api.freeze_inventory_session(companyId, sessionId, vals.scope_filter || null);
			if (!res.ok) return notify(await _apiErrorText(res));
			notify('Inventário congelado com sucesso.', 'success');
			await refresh();
		});

		btnUnfreeze.addEventListener('click', async () => {
			if (!confirm('Descongelar este inventário? Os itens congelados serão removidos.')) return;
			const res = await api.unfreeze_inventory_session(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			notify('Inventário descongelado.', 'info');
			await refresh();
		});

		btnSimulate.addEventListener('click', async () => {
			if (!confirm('Gerar simulação de fechamento?')) return;
			const res = await api.simulate_inventory_close(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			notify('Simulação gerada com sucesso.', 'success');
			await refresh();
		});

		btnPrintProgress.addEventListener('click', async () => {
			const res = await api.print_inventory_progress(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			const data = await res.json();
			_downloadBase64(data.content_base64, `acompanhamento-inv-${sessionId}.pdf`, 'application/pdf');
		});

		btnPrintDivergences.addEventListener('click', async () => {
			const res = await api.print_inventory_divergences(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			const data = await res.json();
			_downloadBase64(data.content_base64, `divergencias-inv-${sessionId}.pdf`, 'application/pdf');
		});

		btnPrintSim.addEventListener('click', async () => {
			const res = await api.print_inventory_simulation(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			const data = await res.json();
			_downloadBase64(data.content_base64, `simulacao-inv-${sessionId}.pdf`, 'application/pdf');
		});

		btnPrintSimSku?.addEventListener('click', async () => {
			const res = await api.print_inventory_simulation_by_sku(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			const data = await res.json();
			_downloadBase64(
				data.content_base64,
				data.filename || `simulacao-sku-inv-${sessionId}.pdf`,
				data.mime_type || 'application/pdf',
			);
		});

		btnExportSimSku?.addEventListener('click', async () => {
			const res = await api.export_inventory_simulation_by_sku(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			const data = await res.json();
			_downloadBase64(
				data.content_base64,
				data.filename || `simulacao-sku-inv-${sessionId}.xlsx`,
				data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			);
		});

		btnPrintClosure.addEventListener('click', async () => {
			const res = await api.print_inventory_closure(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			const data = await res.json();
			_downloadBase64(data.content_base64, `fechamento-inv-${sessionId}.pdf`, 'application/pdf');
		});

		btnClose.addEventListener('click', () => {
			_openCloseConfirmModal(async () => {
				await _startInventoryCloseJob(companyId, sessionId, root);
			});
		});

		btnCancel.addEventListener('click', async () => {
			if (!confirm('Cancelar este inventário?')) return;
			const res = await api.cancel_inventory_session(companyId, sessionId);
			if (!res.ok) return notify(await _apiErrorText(res));
			notify('Inventário cancelado.', 'info');
			await refresh();
		});

		btnClearCounts.addEventListener('click', () => {
			_openClearCountsConfirmModal(async () => {
				const res = await api.clear_inventory_counts(companyId, sessionId);
				if (!res.ok) return notify(await _apiErrorText(res));
				notify('Contagens canceladas. A sessão voltou para Criado e pode ser cancelada.', 'info');
				await refresh();
			});
		});

		btnReload.addEventListener('click', async () => {
			const canDel = root.dataset.invCountsEditable === '1' && root._invCanDeleteCounts !== false;
			await _loadItems(companyId, sessionId, root.dataset.invItemFilter || 'all', canDel);
		});

		btnExportCounts.addEventListener('click', async () => _exportInventoryCountsCsv(companyId, sessionId));

		root.querySelector('#inv-item-filters')?.addEventListener('click', async (ev) => {
			const btn = ev.target.closest('button[data-filter]');
			if (!btn) return;
			root.dataset.invItemFilter = btn.dataset.filter || 'all';
			root.querySelectorAll('#inv-item-filters button').forEach(b => b.classList.toggle('active', b === btn));
			_renderItemsFromCache(root);
		});

		root.querySelector('#inv-item-search')?.addEventListener('input', () => {
			_renderItemsFromCache(root);
		});

		root.querySelector('#inv-items-table-container')?.addEventListener('click', async (ev) => {
			const btn = ev.target.closest('button[data-delete-count-id]');
			if (btn) {
				const countId = btn.dataset.deleteCountId;
				if (!countId) return;
				if (!confirm(`Excluir a contagem #${countId}? Rodadas posteriores do mesmo item também serão removidas para manter a sequência da contagem.`)) return;
				const res = await api.delete_inventory_count(companyId, sessionId, countId);
				if (!res.ok) return notify(await _apiErrorText(res));
				const result = await res.json();
				notify(result.message || 'Contagem excluída.', 'Inventário');
				await refresh();
				return;
			}
			const fillBtn = ev.target.closest('button[data-fill-count-item]');
			if (fillBtn) {
				_fillCountFormFromItem(fillBtn.dataset);
				document.querySelector('#inv-session #count-location-code')?.focus();
				return;
			}
			const skipBtn = ev.target.closest('button[data-skip-item-id]');
			if (skipBtn) {
				const itemId = skipBtn.dataset.skipItemId;
				if (!itemId) return;
				const justification = prompt('Justificativa para pular item (usa saldo congelado como contagem):') || '';
				const res = await api.skip_inventory_item_web(companyId, sessionId, itemId, justification);
				if (!res.ok) return notify(await _apiErrorText(res));
				notify('Item contado via skip (saldo congelado).', 'success');
				await refresh();
			}
		});

		_bindLocationOpsPanel(root, companyId, sessionId, refresh);

		root.querySelector('#bn-save-count').addEventListener('click', async () => {
			const locationCode = root.querySelector('#count-location-code')?.value?.trim() || '';
			const sku = root.querySelector('#count-sku')?.value?.trim() || '';
			const lotNumber = root.querySelector('#count-lot-number')?.value?.trim() || '';
			const expirationDate = root.querySelector('#count-expiration-date')?.value || '';
			const qty = parseInt(root.querySelector('#count-qty')?.value || '-1', 10);
			const obs = root.querySelector('#count-obs')?.value || '';
			const feedback = root.querySelector('#count-feedback');

			if (!locationCode || !sku || !lotNumber || !expirationDate || qty < 0) {
				feedback.textContent = 'Informe posição, SKU, lote, validade e quantidade (>= 0).';
				feedback.style.color = '#dc2626';
				return;
			}

			const res = await api.register_inventory_count_web(companyId, sessionId, {
				location_code: locationCode,
				sku,
				lot_number: lotNumber,
				expiration_date: expirationDate,
				quantity: qty,
				observation: obs,
				origin: 'web',
				idempotency_key: `web-${sessionId}-${locationCode}-${sku}-${lotNumber}-${expirationDate}-${qty}-${Date.now()}`,
			});
			if (!res.ok) {
				feedback.textContent = await _apiErrorText(res);
				feedback.style.color = '#dc2626';
				return;
			}
			const result = await res.json();
			feedback.textContent = `Salvo - ${result.item_status_label || result.item_status}`;
			feedback.style.color = '#16a34a';
			['#count-location-code', '#count-sku', '#count-lot-number', '#count-expiration-date', '#count-qty', '#count-obs'].forEach((selector) => {
				const el = root.querySelector(selector);
				if (el) el.value = '';
			});
			await refresh();
		});
	}

	await refresh();
}

function _badgeClass(status) {
	return {
		20: 'badge-frozen',
		30: 'badge-counting',
		40: 'badge-ready',
		50: 'badge-closed',
		60: 'badge-cancelled',
	}[status] || '';
}

/**
 * Carrega o resumo operacional da sessão para o painel de acompanhamento.
 * @param {string} companyId
 * @param {number|string} sessionId
 * @returns {Promise<object|null>}
 */
async function _loadSummary(companyId, sessionId) {
	const res = await api.inventory_session_summary(companyId, sessionId);
	if (!res.ok)
		return null;
	return await res.json();
}

/**
 * Indica contagem originada do encerramento de posição no coletor.
 * @param {object} count
 */
function _isCloseLocationCount(count) {
	return String(count?.observation || '').startsWith(CLOSE_LOCATION_PREFIX);
}

/**
 * Indica item com ao menos uma contagem de encerramento de posição.
 * @param {object} item
 */
function _itemHasCloseLocationCount(item) {
	return (item?.counts || []).some(_isCloseLocationCount);
}

/**
 * Estatísticas de encerramento de posição a partir dos itens em cache.
 * @param {object[]} items
 */
function _closeLocationStatsFromItems(items) {
	let counts = 0;
	let recount = 0;
	for (const item of items || []) {
		const hasClose = _itemHasCloseLocationCount(item);
		counts += (item.counts || []).filter(_isCloseLocationCount).length;
		if (hasClose && (item.count_status === 'count2_needed' || item.count_status === 'count3_needed'))
			recount += 1;
	}
	return { counts, recount };
}

/**
 * Rótulo de status com destaque para falta física (encerrar posição).
 * @param {object} item
 */
function _formatItemStatusLabel(item) {
	if (!_itemHasCloseLocationCount(item))
		return COUNT_STATUS_LABEL[item.count_status] || item.count_status;
	if (item.count_status === 'count2_needed')
		return '<span class="inv-status-shortage">Falta física — aguard. 2ª</span>';
	if (item.count_status === 'count3_needed')
		return '<span class="inv-status-shortage">Falta física — aguard. 3ª</span>';
	if (item.count_status === 'finalized')
		return '<span class="inv-status-shortage-done">Falta física — finalizado</span>';
	const base = COUNT_STATUS_LABEL[item.count_status] || item.count_status;
	return `<span class="inv-status-shortage">${base}</span>`;
}

/**
 * Renderiza cards e barra percentual do acompanhamento do inventário.
 * @param {object} summary
 * @param {object[]} [items]
 */
function _renderSummary(summary, items = []) {
	const fill = document.querySelector('#inv-session #inv-progress-fill');
	const cards = document.querySelector('#inv-session #inv-summary-cards');
	const last = document.querySelector('#inv-session #inv-last-count');
	const hint = document.querySelector('#inv-session #inv-close-location-hint');
	const pct = Math.max(0, Math.min(100, Number(summary?.progress_percent || 0)));
	const closeStats = summary?.close_location_counts != null
		? { counts: summary.close_location_counts, recount: summary.close_location_recount_items || 0 }
		: _closeLocationStatsFromItems(items);

	if (fill)
		fill.style.width = `${pct}%`;
	if (cards) {
		const cardData = [
			['Status', summary?.status_label || '-'],
			['Progresso', `${pct}%`],
			['Finalizados', `${summary?.finalized_items || 0} / ${summary?.total_items || 0}`],
			['Pendentes', summary?.pending_items || 0],
			['2ª contagem', summary?.count2_needed_items || 0],
			['3ª contagem', summary?.count3_needed_items || 0],
			['Divergências', summary?.divergent_items || 0],
			['Contagens', summary?.total_counts || 0],
		];
		if (closeStats.counts > 0)
			cardData.push(['Encerr. posição', closeStats.counts]);
		cards.innerHTML = cardData.map(([label, value]) => `
			<div class="inv-card${label === 'Encerr. posição' ? ' inv-card-close' : ''}">
				<div class="label">${label}</div>
				<div class="value">${value}</div>
			</div>`).join('');
	}
	if (hint) {
		if (closeStats.recount > 0) {
			hint.style.display = '';
			hint.textContent = `${closeStats.recount} item(ns) com falta física registrada — aguardam 2ª ou 3ª contagem por outro operador. Use operações por posição ou contagem cega.`;
		} else if (closeStats.counts > 0) {
			hint.style.display = '';
			hint.textContent = 'Encerramento de posição registrado pelo coletor (falta física).';
		} else {
			hint.style.display = 'none';
			hint.textContent = '';
		}
	}
	if (last) {
		const c = summary?.latest_count;
		if (!c) {
			last.textContent = 'Nenhuma contagem registrada ainda.';
		} else {
			const closeTag = (c.is_close_location || _isCloseLocationCount(c))
				? ' | encerramento de posição (falta física)'
				: '';
			const obs = c.observation ? ` | ${c.observation}` : '';
			last.textContent = `Última contagem: ${c.counted_by_login || c.counted_by || '-'} | rodada ${c.round} | qtd ${c.quantity}${closeTag} | ${_fmtDateTime(c.counted_on)}${obs}`;
		}
	}
}

/**
 * Carrega itens do escopo aplicando o filtro operacional selecionado.
 * @param {string} companyId
 * @param {number|string} sessionId
 * @param {string} filter
 */
async function _loadItems(companyId, sessionId, filter = 'all', canDeleteCounts = null) {
	const container = document.querySelector('#inv-session #inv-items-table-container');
	if (!container) return;
	container.innerHTML = '<p style="color:#999; font-size:0.8rem;">Carregando...</p>';
	const res = await api.list_inventory_session_items(companyId, sessionId);
	if (!res.ok) {
		container.innerHTML = '<p style="color:#c00;">Erro ao carregar itens.</p>';
		return;
	}
	const items = await res.json();
	const root = document.querySelector('#inv-session');
	if (root) {
		root._invItems = items;
		root._invCanDeleteCounts = canDeleteCounts;
	}
	_renderItemsFromCache(root, filter);
}

function _renderItemsFromCache(root, filter = null) {
	root = root || document.querySelector('#inv-session');
	const container = root?.querySelector('#inv-items-table-container');
	if (!root || !container)
		return;
	const currentFilter = filter || root.dataset.invItemFilter || 'all';
	root.dataset.invItemFilter = currentFilter;
	const query = root.querySelector('#inv-item-search')?.value || '';
	const items = root._invItems || [];
	const allowDelete = root.dataset.invCountsEditable === '1' && root._invCanDeleteCounts !== false;
	const canAct = root.dataset.invCountsEditable === '1';
	container.innerHTML = _buildItemsTable(items, currentFilter, root.dataset.invBlindMode === '1', allowDelete, canAct, query);
}

function _fillCountFormFromItem(dataset) {
	const root = document.querySelector('#inv-session');
	if (!root) return;
	const set = (sel, val) => {
		const el = root.querySelector(sel);
		if (el && val != null && val !== '') el.value = val;
	};
	set('#count-location-code', dataset.locationCode);
	set('#count-sku', dataset.productSku);
	set('#count-lot-number', dataset.lotNumber);
	if (dataset.lotExpiration) {
		const raw = String(dataset.lotExpiration).trim();
		const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
		const br = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
		if (iso) set('#count-expiration-date', `${iso[1]}-${iso[2]}-${iso[3]}`);
		else if (br) set('#count-expiration-date', `${br[3]}-${br[2]}-${br[1]}`);
	}
	set('#loc-ops-code', dataset.locationCode);
	const fb = root.querySelector('#count-feedback');
	if (fb) {
		fb.textContent = 'Campos preenchidos a partir da linha selecionada.';
		fb.style.color = '#64748b';
	}
}

function _buildItemActionsCell(item, canAct) {
	if (!canAct)
		return '<span style="color:#94a3b8;">—</span>';
	const parts = [];
	const loc = item.location_code || '';
	const exp = item.lot_expiration_date || '';
	const ds = [
		`data-fill-count-item="1"`,
		`data-location-code="${_escAttr(loc)}"`,
		`data-product-sku="${_escAttr(item.product_sku || '')}"`,
		`data-lot-number="${_escAttr(item.lot_number || '')}"`,
		`data-lot-expiration="${_escAttr(exp)}"`,
	].join(' ');
	if (['pending', 'count2_needed', 'count3_needed', 'count1_done'].includes(item.count_status))
		parts.push(`<button type="button" class="bn-action bn-primary inv-btn-ghost" ${ds}>Contar</button>`);
	if (item.count_status === 'pending' && item.product_id != null)
		parts.push(`<button type="button" class="bn-action inv-btn-ghost" data-skip-item-id="${item.id}">Skip</button>`);
	if (!parts.length)
		return '<span style="color:#94a3b8;">—</span>';
	return `<div class="inv-row-actions">${parts.join('')}</div>`;
}

function _escAttr(value) {
	return String(value || '')
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/</g, '&lt;');
}

function _bindLocationOpsPanel(root, companyId, sessionId, refresh) {
	if (root.dataset.locOpsBound === '1')
		return;
	root.dataset.locOpsBound = '1';
	const previewEl = root.querySelector('#inv-loc-ops-preview');
	const locInput = root.querySelector('#loc-ops-code');
	let pendingOp = null;

	const hidePreview = () => {
		pendingOp = null;
		if (previewEl) {
			previewEl.style.display = 'none';
			previewEl.innerHTML = '';
			previewEl.className = 'inv-loc-ops-preview';
		}
	};

	const showPreview = (html, variant = '') => {
		if (!previewEl) return;
		previewEl.style.display = '';
		previewEl.className = `inv-loc-ops-preview${variant ? ` ${variant}` : ''}`;
		previewEl.innerHTML = html;
	};

	const locCode = () => (locInput?.value || root.querySelector('#count-location-code')?.value || '').trim();

	root.querySelector('#bn-loc-close-preview')?.addEventListener('click', async () => {
		const code = locCode();
		if (!code) return notify('Informe a posição.');
		hidePreview();
		const res = await api.inventory_close_location_preview(companyId, sessionId, code);
		if (!res.ok) return notify(await _apiErrorText(res));
		const data = await res.json();
		if (data.blocked_reason) {
			showPreview(`<strong>Encerrar posição</strong><p>${_escHtml(data.blocked_reason)}</p>`, 'info');
			return;
		}
		const missing = data.missing_items || [];
		const recount = data.recount_items || [];
		if (!missing.length && !recount.length) {
			showPreview('<strong>Encerrar posição</strong><p>Sem pendências de 1ª contagem nesta posição.</p>', 'info');
			return;
		}
		if (recount.length && !missing.length) {
			const round = recount[0]?.round || 2;
			const skuSample = recount.slice(0, 8).map(r => `<li>SKU ${ _escHtml(r.product_sku) }</li>`).join('');
			const more = recount.length > 8 ? `<li>… e mais ${recount.length - 8} item(ns)</li>` : '';
			pendingOp = { type: 'close', code, phase: 'shortage_recount_confirm' };
			showPreview(
				`<strong>Encerrar posição ${ _escHtml(code) } — ${round}ª contagem</strong>
				<p><b>${recount.length}</b> item(ns) com falta registrada na 1ª rodada aguardam <b>confirmação de falta física</b> (qty 0).</p>
				<p style="color:#b45309;font-size:0.78rem;">Use outro operador que não registrou a 1ª falta.</p>
				<ul>${skuSample}${more}</ul>
				<div class="inv-loc-ops-actions">
					<button type="button" class="bn-action bn-warn" data-loc-op-confirm="close">Confirmar falta na posição</button>
					<button type="button" class="bn-action inv-btn-ghost" data-loc-op-cancel>Cancelar</button>
				</div>`,
				'warn',
			);
			return;
		}
		const lines = missing.map(r => `<li>SKU ${ _escHtml(r.product_sku || '—') }</li>`).join('');
		pendingOp = { type: 'close', code, phase: 'first_shortage' };
		showPreview(
			`<strong>Encerrar posição ${ _escHtml(code) } — 1ª contagem</strong>
			<p>${missing.length} item(ns) pendente(s) serão registrados com quantidade <b>0</b> (falta física):</p>
			<ul>${lines}</ul>
			<div class="inv-loc-ops-actions">
				<button type="button" class="bn-action bn-warn" data-loc-op-confirm="close">Confirmar falta na posição</button>
				<button type="button" class="bn-action inv-btn-ghost" data-loc-op-cancel>Cancelar</button>
			</div>`,
			'warn',
		);
	});

	root.querySelector('#bn-loc-finalize-preview')?.addEventListener('click', async () => {
		const code = locCode();
		if (!code) return notify('Informe a posição.');
		hidePreview();
		const res = await api.inventory_finalize_found_preview(companyId, sessionId, code);
		if (!res.ok) return notify(await _apiErrorText(res));
		const data = await res.json();
		if (data.blocked_reason) {
			showPreview(`<strong>Finalizar achados</strong><p>${_escHtml(data.blocked_reason)}</p>`, 'info');
			return;
		}
		const found = data.found_items || [];
		if (!found.length && !data.pending_placeholder) {
			showPreview('<strong>Finalizar achados</strong><p>Nenhum achado aguardando finalização nesta posição.</p>', 'info');
			return;
		}
		const lines = found.map(r => `<li>SKU ${ _escHtml(r.product_sku) } — lote ${ _escHtml(r.lot_number || '—') }</li>`).join('');
		pendingOp = { type: 'finalize', code };
		showPreview(
			`<strong>Finalizar achados em ${ _escHtml(code) }</strong>
			<p>${found.length} achado(s) irão para <b>2ª contagem</b> por outro operador:</p>
			<ul>${lines || '<li>Placeholder de posição vazia</li>'}</ul>
			<div class="inv-loc-ops-actions">
				<button type="button" class="bn-action bn-primary" data-loc-op-confirm="finalize">Confirmar achados</button>
				<button type="button" class="bn-action inv-btn-ghost" data-loc-op-cancel>Cancelar</button>
			</div>`,
			'info',
		);
	});

	previewEl?.addEventListener('click', async (ev) => {
		if (ev.target.closest('[data-loc-op-cancel]')) {
			hidePreview();
			return;
		}
		const btn = ev.target.closest('[data-loc-op-confirm]');
		if (!btn || !pendingOp) return;
		const op = pendingOp.type;
		const code = pendingOp.code;
		hidePreview();
		let res;
		if (op === 'close')
			res = await api.inventory_close_location(companyId, sessionId, code);
		else if (op === 'finalize')
			res = await api.inventory_finalize_found(companyId, sessionId, code);
		else return;
		if (!res.ok) return notify(await _apiErrorText(res));
		const data = await res.json();
		notify(data.message || 'Operação concluída.', 'success');
		await refresh();
	});
}

function _escHtml(value) {
	return String(value || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

function _buildItemsTable(items, filter = 'all', blindMode = false, canDeleteCounts = false, canAct = false, query = '') {
	if (!items || !items.length)
		return '<p style="color:#999; font-size:0.8rem;">Nenhum item no escopo.</p>';
	const normQuery = _normalizeSearch(query);
	const filtered = items.filter(item => _itemMatchesFilter(item, filter) && _itemMatchesSearch(item, normQuery));
	_updateItemsCount(filtered.length, items.length);
	if (!filtered.length)
		return '<p style="color:#999; font-size:0.8rem;">Nenhum item neste filtro.</p>';
	const rows = filtered.map((item) => {
		const isDivergent = item.count_status === 'count2_needed' || item.count_status === 'count3_needed';
		const cls = item.count_status === 'finalized' ? 'finalized' : (isDivergent ? 'divergent' : '');
		const statusLabel = _formatItemStatusLabel(item);
		const actions = _buildItemActionsCell(item, canAct);
		if (blindMode) {
			return `<tr class="${cls}">
			<td class="inv-col-id">${item.id}</td>
			<td class="inv-col-pos">${item.location_code || '-'}</td>
			<td class="inv-col-status">${statusLabel}</td>
			<td class="inv-col-count">${_buildCountRoundCell(item.counts || [], 1)}</td>
			<td class="inv-col-count">${_buildCountRoundCell(item.counts || [], 2)}</td>
			<td class="inv-col-count">${_buildCountRoundCell(item.counts || [], 3)}</td>
			<td class="inv-col-details">${_buildCountDetails(item.counts || [], canDeleteCounts)}</td>
			<td class="inv-col-actions">${actions}</td>
		</tr>`;
		}
		return `<tr class="${cls}">
			<td class="inv-col-id">${item.id}</td>
			<td class="inv-col-pos">${item.location_code || '-'}</td>
			<td class="inv-col-sku">${item.product_sku || '-'}</td>
			<td class="inv-col-prod">${item.product_name || '-'}</td>
			<td class="inv-col-lot">${item.lot_number || '-'}</td>
			<td class="inv-col-num">${item.frozen_qty_total}</td>
			<td class="inv-col-num">${item.final_qty ?? '-'}</td>
			<td class="inv-col-status">${statusLabel}</td>
			<td class="inv-col-count">${_buildCountRoundCell(item.counts || [], 1)}</td>
			<td class="inv-col-count">${_buildCountRoundCell(item.counts || [], 2)}</td>
			<td class="inv-col-count">${_buildCountRoundCell(item.counts || [], 3)}</td>
			<td class="inv-col-details">${_buildCountDetails(item.counts || [], canDeleteCounts)}</td>
			<td class="inv-col-actions">${actions}</td>
		</tr>`;
	}).join('');

	if (blindMode) {
		return `<p style="font-size:.76rem; color:#64748b; margin:4px 0;">Modo cego ativo: SKU, lote, validade e saldo esperado não são exibidos durante a contagem.</p>
		<table>
		<thead><tr>
			<th class="inv-col-id">ID</th><th class="inv-col-pos">Posição</th><th class="inv-col-status">Status</th><th class="inv-col-count">1ª Contagem</th><th class="inv-col-count">2ª Contagem</th><th class="inv-col-count">3ª Contagem</th><th class="inv-col-details">Digitado / Obs.</th><th class="inv-col-actions">Ações</th>
		</tr></thead>
		<tbody>${rows}</tbody>
	</table>`;
	}

	return `<table>
		<thead><tr>
			<th class="inv-col-id">ID</th><th class="inv-col-pos">Posição</th><th class="inv-col-sku">SKU</th><th class="inv-col-prod">Produto</th>
			<th class="inv-col-lot">Lote</th><th class="inv-col-num">Saldo</th><th class="inv-col-num">Final</th><th class="inv-col-status">Status</th><th class="inv-col-count">1ª Contagem</th><th class="inv-col-count">2ª Contagem</th><th class="inv-col-count">3ª Contagem</th><th class="inv-col-details">Digitado / Obs.</th><th class="inv-col-actions">Ações</th>
		</tr></thead>
		<tbody>${rows}</tbody>
	</table>`;
}

/**
 * Verifica se um item pertence ao filtro visual escolhido pelo gestor.
 * @param {object} item
 * @param {string} filter
 */
function _itemMatchesFilter(item, filter) {
	if (filter === 'pending')
		return !['finalized', 'count2_needed', 'count3_needed'].includes(item.count_status);
	if (filter === 'count2')
		return item.count_status === 'count2_needed';
	if (filter === 'count3')
		return item.count_status === 'count3_needed';
	if (filter === 'finalized')
		return item.count_status === 'finalized';
	if (filter === 'divergent')
		return item.count_status === 'count2_needed' || item.count_status === 'count3_needed';
	if (filter === 'close_location')
		return _itemHasCloseLocationCount(item);
	return true;
}

function _itemMatchesSearch(item, normQuery) {
	if (!normQuery)
		return true;
	return _normalizeSearch(_itemSearchText(item)).includes(normQuery);
}

function _itemSearchText(item) {
	const countText = (item.counts || []).map(c => [
		c.id,
		c.round,
		c.quantity,
		c.counted_by_login,
		c.counted_by,
		c.counted_on,
		c.origin,
		c.device_id,
		c.observation,
		c.input_location_code,
		c.input_product_sku,
		c.input_lot_number,
		c.input_expiration_date,
		c.validation_status,
		c.validation_message,
	].filter(v => v !== null && v !== undefined).join(' ')).join(' ');
	return [
		item.id,
		item.location_code,
		item.product_sku,
		item.product_name,
		item.lot_number,
		item.unit_name,
		item.frozen_qty_available,
		item.frozen_qty_reserved,
		item.frozen_qty_blocked,
		item.frozen_qty_total,
		item.final_qty,
		item.count_status,
		COUNT_STATUS_LABEL[item.count_status],
		countText,
	].filter(v => v !== null && v !== undefined).join(' ');
}

function _normalizeSearch(value) {
	return String(value || '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim();
}

function _updateItemsCount(filtered, total) {
	const el = document.querySelector('#inv-session #inv-items-count');
	if (!el) return;
	el.textContent = filtered === total
		? `${total} item(ns)`
		: `${filtered} de ${total} item(ns)`;
}

/**
 * Monta o histórico de contagens exibido na tabela de acompanhamento.
 * @param {object[]} counts
 * @param {boolean} canDelete
 */
function _buildCountHistory(counts, canDelete = false) {
	if (!counts.length)
		return '<span style="color:#94a3b8;">Sem contagem</span>';
	return `<div class="count-history">${counts.map(c => `
		<div>
			<strong>${c.round}ª</strong>: ${c.quantity}
			<span style="color:#64748b;">por ${c.counted_by_login || c.counted_by || '-'} em ${_fmtDateTime(c.counted_on)} (${c.origin || 'web'})</span>
			${canDelete && c.id ? `<button type="button" class="bn-action bn-danger" data-delete-count-id="${c.id}" style="padding:1px 6px; font-size:.68rem; margin-left:6px;">Excluir</button>` : ''}
			${_buildCountTypedData(c)}
			${c.validation_status === 'divergent' ? `<br><span style="color:#b45309;">Divergência registrada: ${c.validation_message || 'dados digitados divergentes'}</span>` : ''}
			${c.observation ? `<br><em>${c.observation}</em>` : ''}
		</div>`).join('')}</div>`;
}

function _buildCountRoundCell(counts, roundNumber) {
	const count = (counts || []).find(c => Number(c.round) === Number(roundNumber));
	if (!count)
		return '<div class="count-round-cell"><span class="empty">Não realizada</span></div>';
	const user = count.counted_by_login || count.counted_by || '-';
	const origin = count.origin || 'web';
	const divergent = count.validation_status === 'divergent'
		? `<div class="meta" style="color:#b45309;">${count.validation_message || 'Divergência'}</div>`
		: '';
	const closeTag = _isCloseLocationCount(count) ? '<span class="inv-close-tag">Encerrar posição</span>' : '';
	return `<div class="count-round-cell">
		<div class="qty">Qtd ${count.quantity}</div>
		${closeTag}
		<div class="meta">${user}</div>
		<div class="meta">${_fmtDateTime(count.counted_on)} (${origin})</div>
		${divergent}
	</div>`;
}

function _buildCountDetails(counts, canDelete = false) {
	if (!counts?.length)
		return '<span style="color:#94a3b8;">—</span>';
	return `<div class="count-details">${counts.map(c => {
		const typed = _buildCountTypedData(c);
		const divergence = c.validation_status === 'divergent'
			? `<br><span style="color:#b45309;">Divergência: ${c.validation_message || 'dados divergentes'}</span>`
			: '';
		const closeTag = _isCloseLocationCount(c) ? '<br><span class="inv-close-tag">Falta física (encerrar posição)</span>' : '';
		const observation = c.observation ? `<br><em>${c.observation}</em>` : '';
		const del = canDelete && c.id
			? ` <button type="button" class="bn-action bn-danger" data-delete-count-id="${c.id}" style="padding:1px 6px; font-size:.68rem; margin-left:4px;">Excluir</button>`
			: '';
		return `<div><strong>${c.round}ª</strong>${typed || ' —'}${del}${divergence}${closeTag}${observation}</div>`;
	}).join('')}</div>`;
}

function _fmtBrDate(value) {
	if (!value)
		return '';
	const raw = String(value).trim();
	const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
	if (iso)
		return `${iso[3]}/${iso[2]}/${iso[1]}`;
	const br = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
	if (br)
		return `${br[1]}/${br[2]}/${br[3]}`;
	return raw.substring(0, 10);
}

function _buildCountTypedData(count) {
	const parts = [
		count.input_location_code ? `pos ${count.input_location_code}` : '',
		count.input_product_sku ? `SKU ${count.input_product_sku}` : '',
		count.input_lot_number ? `lote ${count.input_lot_number}` : '',
		count.input_expiration_date ? `validade ${_fmtBrDate(count.input_expiration_date)}` : '',
	].filter(Boolean);
	return parts.length
		? `<br><span style="color:#475569;">Digitado: ${parts.join(' | ')}</span>`
		: '';
}

/**
 * Formata datas recebidas da API para exibição operacional.
 * @param {string} value
 */
function _fmtDateTime(value) {
	if (!value)
		return '-';
	const d = new Date(value);
	if (Number.isNaN(d.getTime()))
		return String(value).replace('T', ' ').substring(0, 16);
	return d.toLocaleString('pt-BR');
}

async function _exportInventoryCountsCsv(companyId, sessionId) {
	const root = document.querySelector('#inv-session');
	let items = root?._invItems || [];
	if (!items.length) {
		const res = await api.list_inventory_session_items(companyId, sessionId);
		if (!res.ok)
			return notify(await _apiErrorText(res));
		items = await res.json();
		if (root) root._invItems = items;
	}
	const rows = [];
	for (const item of items) {
		for (const count of (item.counts || [])) {
			rows.push({
				session_id: sessionId,
				scope_item_id: item.id,
				location_code: item.location_code || '',
				product_sku: item.product_sku || '',
				product_name: item.product_name || '',
				lot_number: item.lot_number || '',
				unit_name: item.unit_name || '',
				frozen_qty_total: item.frozen_qty_total ?? '',
				final_qty: item.final_qty ?? '',
				item_status: COUNT_STATUS_LABEL[item.count_status] || item.count_status || '',
				count_id: count.id ?? '',
				round: count.round ?? '',
				quantity: count.quantity ?? '',
				counted_by: count.counted_by_login || count.counted_by || '',
				counted_on: _fmtCsvDateTime(count.counted_on),
				origin: count.origin || '',
				device_id: count.device_id || '',
				input_location_code: count.input_location_code || '',
				input_product_sku: count.input_product_sku || '',
				input_lot_number: count.input_lot_number || '',
				input_expiration_date: _fmtBrDate(count.input_expiration_date),
				validation_status: count.validation_status || '',
				validation_message: count.validation_message || '',
				observation: count.observation || '',
			});
		}
	}
	if (!rows.length)
		return notify('Nenhuma contagem registrada para exportar.', 'Inventário');

	const headers = [
		['session_id', 'Sessão'],
		['scope_item_id', 'Item'],
		['location_code', 'Posição'],
		['product_sku', 'SKU'],
		['product_name', 'Produto'],
		['lot_number', 'Lote'],
		['unit_name', 'Unidade'],
		['frozen_qty_total', 'Saldo congelado'],
		['final_qty', 'Quantidade final'],
		['item_status', 'Status do item'],
		['count_id', 'Contagem ID'],
		['round', 'Rodada'],
		['quantity', 'Quantidade contada'],
		['counted_by', 'Operador'],
		['counted_on', 'Data/hora'],
		['origin', 'Origem'],
		['device_id', 'Dispositivo'],
		['input_location_code', 'Posição digitada'],
		['input_product_sku', 'SKU digitado'],
		['input_lot_number', 'Lote digitado'],
		['input_expiration_date', 'Validade digitada'],
		['validation_status', 'Validação'],
		['validation_message', 'Mensagem validação'],
		['observation', 'Observação'],
	];
	const csv = [
		headers.map(([, label]) => _csvCell(label)).join(';'),
		...rows.map(row => headers.map(([key]) => _csvCell(row[key])).join(';')),
	].join('\r\n');
	_downloadTextFile(`\uFEFF${csv}`, `inventario-${sessionId}-contagens.csv`, 'text/csv;charset=utf-8');
}

function _fmtCsvDateTime(value) {
	if (!value) return '';
	const d = new Date(value);
	if (Number.isNaN(d.getTime()))
		return String(value).replace('T', ' ').substring(0, 19);
	return d.toLocaleString('pt-BR');
}

function _csvCell(value) {
	let text = String(value ?? '');
	if (/^[=+\-@]/.test(text))
		text = `'${text}`;
	return `"${text.replace(/"/g, '""')}"`;
}

function _downloadTextFile(content, filename, mime) {
	const blob = new Blob([content], { type: mime });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
}

function _downloadBase64(b64, filename, mime) {
	const bin = atob(b64);
	const arr = new Uint8Array(bin.length);
	for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
	const blob = new Blob([arr], { type: mime });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
}

/**
 * Extrai uma mensagem operacional legível de respostas de erro da API.
 * @param {Response} response
 * @returns {Promise<string>}
 */
async function _apiErrorText(response) {
	const text = await response.text();
	const clean = String(text || '')
		.replace(/<[^>]+>/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();
	return clean || `Falha na API de inventário (HTTP ${response.status}).`;
}

/**
 * Faz parsing de CSV com separador ';'.
 * Aceita arquivos com ou sem BOM UTF-8. Retorna array de objetos com as chaves do cabeçalho.
 * @param {string} text
 * @returns {{ sku: string, lot_number: string, location_code: string, warehouse_code: string, quantity_expected: string }[]}
 */
function _parseCsv(text) {
	// Remove BOM caso presente
	const clean = text.replace(/^\uFEFF/, '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	const lines = clean.split('\n').filter(l => l.trim() !== '');
	if (lines.length < 2) return [];

	const headers = lines[0].split(';').map(h => h.trim().toLowerCase());
	const rows = [];

	for (let i = 1; i < lines.length; i++) {
		const cells = lines[i].split(';').map(c => c.trim());
		const row = {};
		headers.forEach((h, idx) => { row[h] = cells[idx] ?? ''; });
		// Garante campos numéricos como string (a API aceita string ou number)
		rows.push(row);
	}
	return rows;
}

/**
 * Monta HTML com o resumo do resultado da importação.
 * @param {{ accepted: number, errors: {row: number, message: string}[], total: number }} result
 */
function _buildImportResult(result) {
	const accepted = result?.accepted ?? result?.rows_imported ?? 0;
	const total    = result?.total    ?? result?.rows_read    ?? 0;
	const errors   = result?.errors   ?? [];

	let html = `<div style="margin-bottom:6px;">
		<strong style="color:#16a34a;">${accepted} linha(s) aceita(s)</strong>
		${total ? ` de ${total} lidas` : ''}
		${errors.length ? ` — <strong style="color:#dc2626;">${errors.length} erro(s)</strong>` : ''}
	</div>`;

	if (errors.length) {
		const rows = errors.map(e =>
			`<tr class="row-err"><td>${e.row ?? '-'}</td><td>${e.message || e.error || String(e)}</td></tr>`,
		).join('');
		html += `<table>
			<thead><tr><th>Linha</th><th>Erro</th></tr></thead>
			<tbody>${rows}</tbody>
		</table>`;
	} else {
		html += '<span style="color:#16a34a;">Importação concluída sem erros.</span>';
	}
	return html;
}
